module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace",
    attrs: {
      "id": "epi"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ep"
  }, [_vm._v("The waters become hard like stone, and the face of the deep is frozen.")]), _vm._v(" "), _c('p', {
    staticClass: "ep"
  }), _vm._v(" "), _c('p', {
    staticClass: "ep"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("JOB")]), _vm._v(" 38:30")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd661e1e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 69
// module chunks = 0